/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 用户领取优惠券
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";
export class GetReceiveCouponParams {
  constructor(public activityId: string) {}
}
export default async function (
  couponId: number,
  params: GetReceiveCouponParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/receive-coupon/${couponId}`,
    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
